import { useEffect } from 'react'
import { motion } from 'framer-motion'

const clientLogos = [
  { src: require('../assets/images/solaris-client/client-1.webp'), alt: 'Cairn' },
  { src: require('../assets/images/solaris-client/client-2.png'), alt: 'BSA' },
  { src: require('../assets/images/solaris-client/client-34.png'), alt: 'STL' },
  { src: require('../assets/images/solaris-client/client-4.png'), alt: 'NTPC' },
  { src: require('../assets/images/solaris-client/client-5.png'), alt: 'Unicef' },
  { src: require('../assets/images/solaris-client/client-6.png'), alt: 'Client 6' },
  { src: require('../assets/images/solaris-client/client-7.png'), alt: 'Client 7' },
  { src: require('../assets/images/solaris-client/client-8.png'), alt: 'Client 8' },
  { src: process.env.PUBLIC_URL + '/client-9.svg', alt: 'Client 9' },
  { src: require('../assets/images/solaris-client/client-10.png'), alt: 'Client 10' },
  { src: require('../assets/images/solaris-client/HDFC-bank.webp'), alt: 'HDFC Bank' },
  { src: require('../assets/images/solaris-client/HPCL.jpg'), alt: 'HPCL' },
  { src: require('../assets/images/solaris-client/ICICI-Bank-Logo.jpg'), alt: 'ICICI Bank' },
  { src: process.env.PUBLIC_URL + '/IIT-rurkee.svg', alt: 'IIT Roorkee' },
  { src: require('../assets/images/solaris-client/IndianOilLogo.jpg'), alt: 'Indian Oil' },
  { src: require('../assets/images/solaris-client/JP Group.png'), alt: 'JP Group' },
  { src: require('../assets/images/solaris-client/NSDL_11zon.webp'), alt: 'NSDL' },
  { src: require('../assets/images/solaris-client/Patanjali Ayurveda.avif'), alt: 'Patanjali Ayurveda' },
  { src: require('../assets/images/solaris-client/Philips.png'), alt: 'Philips' },
  { src: require('../assets/images/solaris-client/Reliance.jpg'), alt: 'Reliance' },
  { src: require('../assets/images/solaris-client/U.P. Sugar.png'), alt: 'U.P. Sugar' },
  { src: require('../assets/images/solaris-client/Bluestar.png'), alt: 'Bluestar' },
  { src: require('../assets/images/solaris-client/bhu.png'), alt: 'BHU' },
  { src: require('../assets/images/solaris-client/kenra-bank.png'), alt: 'Kenra Bank' },
  { src: process.env.PUBLIC_URL + '/up-vidhan-sabha.svg', alt: 'UP Vidhan Sabha' },
]

export default function Clients() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="breadcrumb-hero">
        <div className="breadcrumb-overlay"></div>
        <div className="breadcrumb-content">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h1 className="breadcrumb-title">
                  Our <span className="breadcrumb-highlight">Trusted Clients</span>
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="breadcrumb-pattern"></div>
      </section>

      <section className="py-5" style={{ backgroundColor: '#f8fafc' }}>
        <div className="container">
          <motion.div
            className="text-center mb-5"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="fw-bold mb-3" style={{ fontSize: 'clamp(1.8rem, 4vw, 2.5rem)', color: '#111827' }}>
              Our Trusted <span style={{ color: '#0ea5e9' }}>Clients</span>
            </h2>
            <p className="text-muted mx-auto" style={{ maxWidth: '600px', fontSize: '1.05rem' }}>
              We are proud to work with a diverse range of clients, from startups to Fortune 500 companies across various industries.
            </p>
          </motion.div>

          <div className="row g-4">
            {clientLogos.map((client, i) => (
              <div className="col-6 col-sm-4 col-md-3 col-lg-2" key={i}>
                <motion.div
                  className="bg-white rounded-4 d-flex align-items-center justify-content-center p-3 h-100"
                  style={{
                    minHeight: '120px',
                    boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03)',
                    border: '1px solid #f1f5f9',
                    cursor: 'default'
                  }}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: i * 0.03 }}
                  viewport={{ once: true }}
                  whileHover={{ y: -5, boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)', borderColor: '#e2e8f0' }}
                >
                  <img
                    src={client.src}
                    alt={client.alt}
                    className="img-fluid"
                    style={{ maxHeight: '70px', maxWidth: '100%', objectFit: 'contain' }}
                  />
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
